(ns manage.ad-variant-preview.bottom-panel
  (:require ["@mui/material/Button$default" :as Button]
            ["@mui/material/IconButton$default" :as IconButton]
            ["@mui/material/Paper$default" :as Paper]
            ["@mui/material/Popper$default" :as Popper]
            ["@mui/material/Slider$default" :as Slider]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/SvgIcon$default" :as SvgIcon]
            ["@mui/material/Tooltip$default" :as Tooltip]
            ["@mui/material/Typography$default" :as Typography]
            ["@mui/material/styles" :as styles]
            ["material-ui-popup-state/hooks" :as muips]
            ["src/svg/arrows/arrow-clockwise-play.svg$default" :as ArrowClockwisePlay]
            ["src/svg/arrows/arrow-clockwise.svg$default" :as ArrowClockwise]
            ["src/svg/arrows/arrow-left-from-line.svg$default" :as ArrowLeftFromLine]
            ["src/svg/arrows/arrow-right-from-line.svg$default" :as ArrowRightFromLine]
            ["src/svg/chevron/chevron-up.svg$default" :as ChevronUp]
            ["src/svg/controls/media_player_call/media-pause.svg$default" :as MediaPause]
            ["src/svg/controls/media_player_call/media-play-outline.svg$default" :as MediaPlay]
            ["src/svg/controls/media_player_call/volume-slash.svg$default" :as VolumeSlash]
            ["src/svg/controls/media_player_call/volume-wave-2.svg$default" :as Volume]
            ["src/svg/inform/min.svg$default" :as Min]
            ["src/svg/inform/plus.svg$default" :as Plus]
            ["src/svg/objects/clock-dashed-quarter.svg$default" :as ClockDashedQuarter]
            ["src/svg/shapes/rectangle/rectangle-arrows-outward.svg$default" :as FitToView]
            ["src/svg/shapes/rectangle/rectangle-viewfinder.svg$default" :as RectangleViewfinder]
            [common.util :refer [spread-props]]
            [common.widgets.video-timeline :refer [seconds-to-str timeline]]
            [manage.ad-variant-preview.db :as db]
            [manage.ad-variant-preview.hooks :as hooks]
            [manage.ad-variant-preview.viewport :as viewport :refer [dispatch]]
            [uix.core :as uix :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

(defui action-button [{:keys [label active children] :as props}]
  ($ Tooltip
     {:placement "top"
      :title label}
     ($ IconButton
        (spread-props (dissoc props :label :active :children)
                      {:aria-label label
                       :className (when active "button-active")})
        children)))

(defui reload-button
  []
  (let [{:keys [event-target]} (viewport/use-context)]
    ($ action-button
       {:label "Reload"
        :on-click (fn [_e] (dispatch event-target "reload-display"))}
       ($ ArrowClockwise))))

(defui minimap [{:keys [item-places]}]
  (let [{:keys [w-a h-a]} (viewport/use-context)
        theme (styles/useTheme)
        [x y k] (use-subscribe [::db/pos])
        ;; Find min/max coordinates for preview items
        [min-x max-x min-y max-y]
        (uix/use-memo (fn []
                        (reduce (fn [[min-x max-x min-y max-y] {:keys [x y w h]}]
                                  [(min min-x x)
                                   (max max-x (+ x w))
                                   (min min-y y)
                                   (max max-y (+ y h))])
                                [0 0 0 0]
                                (vals item-places)))
                      [item-places])
        ;; Find min/max of the projected viewport
        ;; In non-canvas the item coordinates are already scaled.
        ;; Add list-view bottom/right padding so the minimap has the
        ;; same padding at the bottom/right as what the container will show when
        ;; scrolled to the end.
        rem2 (js/parseInt (.spacing theme 4))
        r-scale (/ 1 k)
        min-x (min min-x (* r-scale (- x)))
        max-x (max (+ max-x rem2) (* r-scale (- w-a x)))
        min-y (min min-y (* r-scale (- y)))
        max-y (max (+ max-y rem2) (* r-scale (- h-a y)))]
    ($ :svg
       ;; Not sure if changing viewBox is the most efficient operation.
       ;; Alternative would be static viewBox and extra transform? But that
       ;; would be more complicated.
       {:viewBox (str min-x " " min-y " " (- max-x min-x) " " (- max-y min-y))
        ;; Declare viewport dimensions to keep correct aspect ratio
        :width w-a
        :height h-a
        ;; Use available width, height to keep aspect ratio and but limit max height
        :style {:width "100%"
                :height "auto"
                :max-height "300px"}}
       (for [[uuid {:keys [x y w h]}] item-places]
         ($ :rect
            {:key uuid
             :x x
             :y y
             :width w
             :height h
             :fill "#aaa"}))
       ($ :g
          ;; Reverse transform order and transformations.
          ;; We aren't transforming the viewport but the box that represents the viewport.
          {:transform (str "scale(" r-scale ") translate(" (- (int x)) ", " (- (int y)) ") ")}
          ($ :rect
             {:x 0
              :y 0
              :width w-a
              :height h-a
              ;; FIXME: Use theme color
              :fill "rgba(0,0,150,0.25)"})))))

(defui zoom-slider [{:keys [scale item-places]}]
  (let [{:keys [mode] :as ctx} (viewport/use-context)
        ;; Debounce flag for wheel events
        wheel-callback (uix/use-ref false)]
    ($ Paper
       {:elevation 2
        :p 2
        :sx #js {:width 250
                 :mb 4}
        ;; Trigger one zoom from wheel events every 200ms
        :onWheel (fn [e]
                   (when-not @wheel-callback
                     (viewport/zoom ctx (pos? (.-deltaY e)))
                     (reset! wheel-callback true)
                     (js/setTimeout (fn []
                                      (reset! wheel-callback false))
                                    200)))}
       ($ Stack
          {:direction "column"
           :spacing 1}
          (when (= mode "canvas")
            ($ minimap {:item-places item-places}))
          ($ Stack
             {:direction "row"
              :alignItems "center"
              :spacing 1}
             ($ IconButton
                {:onClick (fn [_]
                            (viewport/zoom ctx true))}
                ($ Min))

             ($ Slider
                {:value (Math/round (* 100 scale))
                 :steps 1
                 :min (* 100 (:min-zoom ctx))
                 :max 100
                 :onChange (fn [_e value]
                             (viewport/zoom-to ctx (/ value 100)))})

             ($ IconButton
                {:onClick (fn [_]
                            (viewport/zoom ctx false))}
                ($ Plus)))))))

(defui ^:memo bottom-panel [{:keys [scale item-places video-status video-controls has-video-components]}]
  (let [{:keys [mode] :as ctx} (viewport/use-context)
        popup-state (muips/usePopupState #js {:variant "popper"})

        {:keys [auto-replay
                audio-active-variant
                toggle-auto-replay
                playing
                toggle-play
                timeline-disabled
                timeline-selection
                timeline-progress
                timeline-selection-editing
                toggle-timeline-selection-editing
                set-timeline-selection
                set-timeline-progress
                restore-timeline-progress
                mute-all-videos
                max-duration]}
        (hooks/use-video-controls {:video-status video-status
                                   :video-controls video-controls})

        [timeline-start timeline-end] timeline-selection]

    ($ Paper
       {:direction "column"
        :spacing 1
        :sx #js {:padding 1.5
                 :mb 0.5
                 ".MuiIconButton-root" #js {:borderRadius "3px"
                                            :color "grey.10"}
                 ".button-active" #js {:color "primary.500"
                                       :backgroundColor "primary.100"}}}
       ($ Stack
          {:direction "row"
           :justifyContent "space-between"}
          ($ Stack
             {:direction "row"
              :flexGrow 1
              :flexBasis 0
              :alignItems "center"
              :spacing 1}
             (if has-video-components
               ($ :<>
                  ($ action-button
                     {:on-click toggle-timeline-selection-editing
                      :label "Adjust timeline"
                      :active timeline-selection-editing}
                     ($ ClockDashedQuarter {:width 24 :height 24}))

                  ($ action-button
                     {:on-click mute-all-videos
                      :label ($ :<> "Mute videos"
                                ($ :br)
                                ($ :br)
                                "Use the volume button on an individual variant to play its sound")}
                     ($ (if audio-active-variant
                          Volume
                          VolumeSlash)))

                  ($ action-button
                     {:on-click toggle-auto-replay
                      :label "Toggle auto replay"
                      :active auto-replay}
                     ($ ArrowClockwisePlay))

                  ($ action-button
                     {:label (if playing "Pause" "Play")
                      :on-click toggle-play}
                     (if playing ($ MediaPause) ($ MediaPlay {:width 24 :height 24}))))
               ($ reload-button))

             (when has-video-components
               ($ :<>
                  ($ Typography
                     {:component "span"}
                     (seconds-to-str timeline-progress)))))

          ($ Stack
             {:direction "row"
              :flexGrow 1
              :flexBasis 0
              :justifyContent "flex-end"
              :alignItems "center"
              :spacing 1}
             ($ action-button
                {:onClick (fn [_e]
                            (viewport/fit-to-view ctx))
                 :label "Fit to view"}
                ($ FitToView {:width 24 :height 24}))

             ($ action-button
                {:onClick (fn [_]
                            (viewport/center-on-focused ctx))
                 :label "Actual size"}
                ($ RectangleViewfinder))

             ($ Button
                (spread-props {:className (when (.-isOpen popup-state)
                                            "button-active")
                               :sx #js {:fontSize "lg"
                                        ;; Set width so that changing from 100% to 50% or such
                                        ;; doesn't effect the size of the button, which would
                                        ;; affect positions of other elements.
                                        :minWidth "8rem"
                                        :color "text.primary"
                                        ;; Keep caret on the right corner, right aligned text
                                        :justifyContent "flex-end"}}
                              (muips/bindToggle popup-state))
                (str (Math/round (* 100 scale)) "%")
                ($ ChevronUp))

             ($ Popper
                (spread-props {:placement  "top-end"
                               ;; FIXME: Use theme value
                               :sx #js {:zIndex 5000}}
                              (muips/bindPopper popup-state))
                ($ zoom-slider
                   {:mode mode
                    :scale scale
                    :item-places item-places}))))
       (when has-video-components
         ($ :<>
            ($ Stack
               {:direction "row"
                :sx #js {:my 0.5
                         :height "24px"
                         :alignItems "center"}}
               (when timeline-selection-editing
                 ($ Button
                    {:variant "text"
                     :onClick (fn [_e] (set-timeline-selection nil nil))
                     :sx #js {:py 0}}
                    "Reset selection")))
            (if timeline-selection-editing
              ($ timeline
                 {:value #js [(or timeline-start 0)
                              (or timeline-end max-duration)]
                  :max max-duration
                  :disabled timeline-disabled
                  :step 1
                  :onChange (fn [_e [start end] active-thumb]
                              (let [start (if (= 0 active-thumb) start (min start (- end 1)))
                                    end (if (= 1 active-thumb) end (max end (+ start 1)))]
                                (set-timeline-selection start end)))
                  :onChangeCommitted (fn []
                                       ;; Always place the playhead to selection start when selection is ready
                                       (set-timeline-progress timeline-start))
                  :disableSwap true
                  :track false
                  :valueLabelDisplay "on"
                  :valueLabelFormat (fn [x]
                                      ($ SvgIcon
                                         {:component (if (= (or timeline-start 0) x)
                                                       ArrowRightFromLine
                                                       ArrowLeftFromLine)
                                          :sx #js {:color "white"}}))})
              ($ timeline
                 {:value timeline-progress

                  ;; If no video variant selected, no duration available, disabled.
                  :max max-duration
                  :disabled timeline-disabled
                  :timeline-selection timeline-selection

                  ;; NOTE: most video is probably around 24-30fps, max 120-240fps for some special cases?
                  ;; Currently 30fps
                  :step (/ 1 30)
                  :onChange (fn [_e v]
                              (set-timeline-progress v {:save-position true}))
                  :onChangeCommitted restore-timeline-progress})))))))
